import React from 'react'

/**
 * Generic shimmering placeholder block. Composes via Tailwind so callers
 * pass width / height / rounded / margin classes directly.
 *
 * Usage:
 *   <SkeletonBlock className="h-4 w-32 rounded-md" />
 *   <SkeletonBlock className="h-12 w-12 rounded-full" />
 *
 * The shimmer keyframe lives in src/styles/design-tokens.css and respects
 * prefers-reduced-motion automatically.
 */
function SkeletonBlock({ className = '', ...rest }) {
  return <div className={`shimmer ${className}`} aria-hidden="true" {...rest} />
}

export default SkeletonBlock
